import React, {forwardRef} from "react";

interface StsDatePickerCustomInputProps {
    isMobileOrTablet: boolean,
    activateSingleCalendar: (value: boolean) => void,
    activateStsCalendar: (value: boolean) => void,
}

interface StsDatePickerCustomInputTypes {
    value?: any,
    onClick?: (any?) => (any),
    props: StsDatePickerCustomInputProps,
}

const StsDatePickerCustomInput = forwardRef(({value, onClick, props}: StsDatePickerCustomInputTypes, ref:React.ForwardedRef<any>) => (
    <span
        ref={ref}
        // overloaded onClick, as there doesn't seem to be better solution atm.
          onClick={() => {
              onClick();
              if (props.isMobileOrTablet) {
                  props.activateSingleCalendar(true)
                  props.activateStsCalendar(true)
              }
          }}
          className="btn btn--blue sts-date-picker-text"
    >
        {value}
    </span>
));

export default StsDatePickerCustomInput